import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e21e3ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`tw-w-full tw-flex tw-flex-col`)
}
const _hoisted_2 = {
  class: "tw-cursor-pointer tw-flex tw-justify-center tw-items-center tw-gap-[8px]",
  "data-cy": "assessment-switcher-dropdown-item"
}
const _hoisted_3 = { class: "tw-font-[500]" }
const _hoisted_4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "7",
  viewBox: "0 0 10 7",
  fill: "none"
}
const _hoisted_5 = ["fill"]
const _hoisted_6 = {
  key: 0,
  class: "items"
}

import { ref, watch } from "vue";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import AssessmentChecklistStatusTag from "@/components/assessment/assessmentChecklistStatusTag.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentSwitcherDropdownItem',
  props: {
  item: {
    type: Object,
    required: true,
  },
  searchValue: {
    type: String,
    required: false,
    default: "",
  },
  level: {
    type: Number,
    required: true,
    default: 0,
  },
  isModalOpen: {
    type: Boolean,
    required: false,
    default: false,
  },
  isTopLevelOnly: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["update:selected", "update:child-selected"],
  setup(__props, { emit: emits }) {

const props = __props;




const isOpen = ref(false);
watch(
  () => props.isModalOpen,
  (value) => {
    if (!value && isOpen.value) {
      isOpen.value = false;
    }
    // if (
    //   value &&
    //   props.item?.checklistParent?.find(
    //     (item) => item.checklistId === currentChecklistReportId.value,
    //   )
    // ) {
    //   isOpen.value = true;
    // }
  },
);
watch(
  () => props.searchValue,
  (value) => {
    if (value && !isOpen.value) {
      isOpen.value = true;
    }
    if (!value && isOpen.value) {
      isOpen.value = false;
    }
  },
);
const onClickAssessmentItem = () => {
  emits("update:selected", props.item);
};

return (_ctx: any,_cache: any) => {
  const _component_assessmentSwitcherDropdownItem = _resolveComponent("assessmentSwitcherDropdownItem", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`tw-min-h-[44px] tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-self-stretch tw-py-[10px] tw-pl-[24px] tw-pr-[21px] ${
        __props.level === 1 ? '!tw-pl-[57px] !tw-pr-[21px]' : ''
      }`),
      onClick: onClickAssessmentItem
    }, [
      _createElementVNode("div", _hoisted_2, [
        (
            __props.item && __props.item?.checklistDateReporting
              ? __props.item?.checklistDateReporting
              : __props.item?.checklistDateCreated
          )
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(`tw-text-[#231F20] tw-text-[11px] tw-not-italic tw-font-[400] tw-leading-[130%] title tw-line-clamp-2 tw-flex-1 ${
            __props.item.isHidden ? 'tw-opacity-50' : ''
          }`)
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(__props.item?.checklistName), 1),
              _createTextVNode(_toDisplayString(` - ${_unref(convertUTCTimeToLocalTime)(
              __props.item?.checklistDateReporting
                ? __props.item?.checklistDateReporting
                : __props.item?.checklistDateCreated,
            )}`), 1)
            ], 2))
          : _createCommentVNode("", true),
        _createVNode(AssessmentChecklistStatusTag, {
          "checklist-status": __props.item.checklistStatus,
          "checklist-status-id": __props.item.checklistStatusId,
          "is-loading": false,
          "class-name": ` tw-px-[8px] tw-leading-[130%] tw-h-[24px] ${
            __props.item.isHidden ? 'tw-opacity-50' : ''
          }`
        }, null, 8, ["checklist-status", "checklist-status-id", "class-name"])
      ]),
      (__props.item.checklistParent && __props.level === 0 && !__props.isTopLevelOnly)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(`arrowIcon ${
          isOpen.value ? 'rotated tw-pr-[10px]' : 'tw-pl-[10px] '
        } `),
            onClick: [
              _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              _cache[1] || (_cache[1] = 
          () => {
            isOpen.value = !isOpen.value;
          }
        )
            ]
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_4, [
              _createElementVNode("path", {
                d: "M0.104884 2.00642L4.67976 7.19266C4.72096 7.23621 4.77061 7.2709 4.82567 7.2946C4.88073 7.31831 4.94005 7.33054 5 7.33054C5.05995 7.33054 5.11927 7.31831 5.17433 7.2946C5.22939 7.2709 5.27904 7.23621 5.32024 7.19266L9.89512 2.00642C9.93169 1.96522 9.95972 1.91717 9.97757 1.86505C9.99541 1.81293 10.0027 1.75778 9.99909 1.70281C9.99458 1.6474 9.97901 1.59345 9.95329 1.54417C9.92758 1.49488 9.89224 1.45124 9.84937 1.41584L9.07996 0.771202C9.03793 0.734847 8.98904 0.707283 8.93618 0.690139C8.88332 0.672995 8.82756 0.666619 8.77219 0.671387C8.71709 0.675373 8.66333 0.690299 8.61406 0.715292C8.56479 0.740285 8.52099 0.774843 8.48522 0.816951L5.0707 4.74718C5.04968 4.76801 5.02128 4.77969 4.99168 4.77969C4.96209 4.77969 4.93369 4.76801 4.91266 4.74718L1.51478 0.816951C1.44755 0.736646 1.35249 0.684663 1.2486 0.671387C1.19352 0.666053 1.13793 0.671766 1.08508 0.688192C1.03223 0.704618 0.983193 0.731424 0.940838 0.767043L0.150633 1.41584C0.107763 1.45124 0.0724248 1.49487 0.0467083 1.54417C0.0209918 1.59345 0.0054186 1.6474 0.000909419 1.70281C-0.00273159 1.75778 0.00458484 1.81293 0.0224338 1.86505C0.0402828 1.91717 0.0683087 1.96522 0.104884 2.00642Z",
                fill: isOpen.value ? '#387DFF' : '#B7B7B7'
              }, null, 8, _hoisted_5)
            ]))
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    (isOpen.value && __props.item && __props.item.checklistParent && !__props.isTopLevelOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.checklistParent, (child, index) => {
            return (_openBlock(), _createBlock(_component_assessmentSwitcherDropdownItem, {
              key: index,
              item: child,
              level: __props.level + 1,
              "onUpdate:selected": _cache[2] || (_cache[2] = 
          (cl) => {
            emits('update:selected', cl);
          }
        )
            }, null, 8, ["item", "level"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})